import _ from 'lodash'
import $ from 'jquery'
import template from './note-display-form.hbs'
import StackForm from './stack-form'
import LabeledToggle from 'scoreboard/components/labeled-toggle'
import CalendarRangeSelector from 'scoreboard/components/calendar-range-selector'
import reportConstants from 'scoreboard/reports/report-constants'

const DISPLAY_PROPERTIES = [reportConstants.NOTE_DISPLAY_PROP_CREATED_DATE,
	reportConstants.NOTE_DISPLAY_PROP_AUTHOR,reportConstants.NOTE_DISPLAY_PROP_APPLIES_TO,
	reportConstants.NOTE_DISPLAY_PROP_DOMAIN_LABEL,reportConstants.NOTE_DISPLAY_PROP_REPLIES,
	reportConstants.NOTE_DISPLAY_PROP_DESCENDANTS]

const NoteDisplayForm = StackForm.extend({

	className: 'note-display-form report',

	events: {
		'change input[type=checkbox]': '_onChangeCheckbox'
	},

	/**
	 * View for editing the formatting of a stack of a designer report
	 *
	 * @param {ReportStack} options.model the Report Stack
	 * @param {ReportModel} options.designerModel the model of the designer
	 * @param {ReportTableModel} options.tableModel the model of the table
	 * @param {ReportColumn} options.column the model of one of a column in a stack
	 */
	initialize: function(options = {}) {
		StackForm.prototype.initialize.apply(this, arguments)
		this.displayOptions = _.cloneDeep(this.column.get('noteDisplayOptions'))
	},

	render: function() {
		let context = this._renderDisplayProperties()
		this.$el.html(template(context))

		if (this.reportModel.reportDomainType == 'scorecard-item') {
			this._renderDisplayType()
		}

		return StackForm.prototype.render.apply(this, arguments)
	},

	_renderDisplayType: function() {
		this.noteTypeToggle = new LabeledToggle({
			name: 'displayType',
			options: [{
				value: reportConstants.NOTE_DISPLAY_TYPE_ALL,
				label: 'report.designer.noteDisplayType.all'
			},{
				value: reportConstants.NOTE_DISPLAY_TYPE_PERIOD_SPECIFIC_ONLY,
				label: 'report.designer.noteDisplayType.periodSpecificOnly'
			},{
				value: reportConstants.NOTE_DISPLAY_TYPE_GENERAL_ONLY,
				label: 'report.designer.noteDisplayType.generalOnly'
			}],
			value: _.get(this.displayOptions, 'displayType', reportConstants.NOTE_DISPLAY_TYPE_ALL)
		})

		this.$('.labeled-toggle-container').append(this.noteTypeToggle.el)
		this.noteTypeToggle.render()
		this.listenTo(this.noteTypeToggle, 'change',
			this._onChangeNoteType.bind(this))

		this.calendarRangeSelector = new CalendarRangeSelector({
			range: this.displayOptions.range,
			canChangeCalendar: true,
			allowAppCalendar: true
		})

		this.$('.calendar-range-selector-container')
			.append(this.calendarRangeSelector.el)
		this.calendarRangeSelector.render()
		this._onChangeNoteType(this.noteTypeToggle.val())

		this.$('.display-type').removeClass('is-not-displayed')
	},

	_renderDisplayProperties: function() {
		let toggles = []

		_.each(DISPLAY_PROPERTIES, displayProperty => {
			let label = `report.designer.noteDisplay.${displayProperty}`
			if (displayProperty == reportConstants.NOTE_DISPLAY_PROP_APPLIES_TO) {
				if (this.reportModel.reportDomainType == 'scorecard-item') {
					label = 'report.designer.noteDisplay.calendarPeriod'
				}
			} else if (displayProperty == reportConstants.NOTE_DISPLAY_PROP_DOMAIN_LABEL) {
				label = `report.designer.noteDisplay.${this.reportModel.reportDomainType}`
			}

			let checked = this.displayOptions.displayProperties[displayProperty] === true
			toggles.push({ label, checked, displayProperty })
		})

		return toggles
	},

	_onChangeNoteType: function(value) {
		this.$('.calendar-range-selector-container')
			.toggleClass('is-not-displayed', value == reportConstants.NOTE_DISPLAY_TYPE_GENERAL_ONLY)
		this.displayOptions.displayType = value
	},

	_onChangeCheckbox: function(e) {
		var cb = $(e.target)
		this.displayOptions.displayProperties[cb.attr('name')]  = cb.prop('checked')
	},

	_onDone: function() {
		if (this.reportModel.reportDomainType == 'scorecard-item') {
			this.displayOptions.range = this.calendarRangeSelector.val()
		}
		this.column.set('noteDisplayOptions', this.displayOptions)
		return StackForm.prototype._onDone.apply(this, arguments)
	},

	remove: function() {
		StackForm.prototype.remove.apply(this, arguments)
		_.invokeMap([this.noteTypeToggle, this.calendarRangeSelector], 'remove')
	}
})

export default NoteDisplayForm
NoteDisplayForm.__filename__ = 'reports/common/note-display-form.js'
